export const SolidCheck = ({
  size = "22",
  color = "#52835A",
}: {
  size?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M7.5 0C3.64008 0 0.5 3.14008 0.5 7C0.5 10.8599 3.64008 14 7.5 14C11.3599 14 14.5 10.8599 14.5 7C14.5 3.14008 11.3599 0 7.5 0ZM7.44692 8.99442C7.22117 9.22017 6.92425 9.33275 6.62617 9.33275C6.32808 9.33275 6.02825 9.219 5.80017 8.9915L4.17733 7.41883L4.98992 6.58058L6.61917 8.15967L10.0077 4.83408L10.8267 5.66533L7.44692 8.99442Z"
        fill="currentColor"
      />
    </svg>
  );
};
